import React from 'react';

import { withAnalyticsEvents } from '@atlaskit/analytics-next';

import { StickyWrapper } from './StickyWrapper';

export const StickyBanner = withAnalyticsEvents()(StickyWrapper);
